import axios from "axios";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { baseUrl, mainBaseUrl } from "../App";
import CerImgComp from "./cerImgComp";
import cerImgComp from "./cerImgComp";
import { htmlContent } from "./HtmlContent";
import "./LeadTemp.scss";
const LeadTemp = () => {
  const location = useLocation();
  const eventID = location.state.eventID;
  const certifiicateEmails = location.state.eventData.certificates;
  const [leads, setLeads] = React.useState([]);
  const [templates, setTemplates] = React.useState([]);
  const [selectedLead, setSelectedLead] = React.useState(null);
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  const [LeadIdx, setLeadIdx] = React.useState();
  const [tempIdx, setTempIdx] = React.useState();
  const [status, setStatus] = React.useState({});
  const history = useHistory();
  const [emailStatus, setEmailStatus] = React.useState();
  const [whatCall, setWhatCall] = React.useState("");
  var control = 0;

  // var emails = [];
  const getImageData = ({ template, idx }) => {
    axios
      .get(mainBaseUrl + template.certificateTemplateImage.uri)
      .then((response) => {
        return Buffer.from(response.data.image.data, "binary").toString(
          "base64"
        );
      });
  };

  // verify certificate
  const verifyCertificate = () => {
    setWhatCall("verifing certificate....");
    var config = {
      method: "post",
      url: `${mainBaseUrl}/verifyCertificates/${eventID}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then((response) => {
        createBuffersAndSendEmails();
      })
      .catch((e) => {
        alert(e.response.statusText);
        console.log(e.response.data);
      });
  };

  // get all leads
  const getLeads = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/leads`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setLeads(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // get all templates
  const getTemplates = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/certificate/template`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setTemplates(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // get the status if the metadata is added
  const getStatus = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/certificate/metadataStatus/${eventID}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setStatus(response.data);
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  useEffect(() => {
    getStatus();
    getLeads();
    getTemplates();
    // console.log(location.state.eventData.eventName);
  }, []);

  const createBuffersAndSendEmails = async () => {
    var emailList = [];
    await certifiicateEmails.map((email) => {
      emailList.push(email.email);
    });
    console.log(emailList);
    const emailsBuffer = emailList;
    var newBuffer = emailsBuffer;

    while (newBuffer.length > 0) {
      const emailList = newBuffer.slice(0, 15);
      sendEmail({ emailList: emailList });
      control++;
      var newBuffer_temp = newBuffer.filter(
        (email) => !emailList.includes(email)
      );
      newBuffer = newBuffer_temp;
    }
  };

  const sendEmail = async ({ emailList }) => {
    setWhatCall("sending mails....");
    var data = JSON.stringify({
      server_id: "6187e0a1992b2173634847a0",
      name: "event.admin@gdscghrce.dev",
      bcc: emailList,
      subject: `Here's your certificate for ${location.state.eventData.eventName} | GDSC GHRCE`,
      html_body: htmlContent({
        eventname: location.state.eventData.eventName,
        id: eventID,
      }),
    });

    var config = {
      method: "post",
      url: "https://gdscghrce-email-gateway.deta.dev/v1/api/mail/sendMail",
      headers: {
        accept: "application/json",
        "API-KEY": baseUrl,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")} `,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data) + " " + emailList);
        control--;
        if (control === 0) {
          history.push("/dashboard");
        }
      })
      .catch(function (error) {
        console.log("call failed ");
        sendEmail(emailList);
      });
  };

  const btnValidator = async () => {
    if (status.leadOK && status.certificateOK) {
      verifyCertificate();
      console.log("only mail block");
    } else {
      console.log("not only mail block");
      addLeadToTemplate();
    }
  };

  const addLead = async () => {
    setWhatCall("adding lead....");
    var config = {
      method: "patch",
      url: `${mainBaseUrl}/leads/link/${eventID}/${selectedLead}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .then(() => {
        addTemplate();
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const addTemplate = async () => {
    setWhatCall("adding template....");
    var config = {
      method: "patch",
      url: `${mainBaseUrl}/certificate/linkedEvent/${selectedTemplate}/${eventID}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .then(() => {
        verifyCertificate();
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  const addLeadToTemplate = async () => {
    if (selectedLead != null && selectedTemplate != null) {
      addLead();
    } else {
      alert("Please select a lead and a template");
    }
  };
  if (whatCall != "") {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {whatCall}
      </div>
    );
  }
  return (
    <div className="leadTempContainer">
      <div className="leadTitle">
        <h1>Select Lead</h1>
        {leads.length === 0 ? (
          <p
            style={{
              margin: "10px",
            }}
          >
            Loading....
          </p>
        ) : status.leadOK ? (
          <p
            style={{
              margin: "10px",
            }}
          >
            Lead Already Added
          </p>
        ) : (
          <div className="leads">
            {leads.map((lead, idx) => {
              return (
                <div
                  onClick={() => {
                    setLeadIdx(idx);
                    setSelectedLead(lead._id);
                  }}
                  className="lead"
                  style={{
                    border:
                      LeadIdx === idx
                        ? "3px solid cornflowerblue"
                        : "3px solid black",
                  }}
                >
                  <div className="info">
                    <div className="leadName">{lead.name}</div>
                    <div className="leadEmail">{lead.email}</div>
                    <div className="leadTenure">{lead.leadTenure}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="templateTitle">
        <h1>Select Template</h1>
        {templates.length === 0 ? (
          <p
            style={{
              margin: "10px",
            }}
          >
            Loading...
          </p>
        ) : status.certificateOK ? (
          <p
            style={{
              margin: "10px",
            }}
          >
            Template Already added
          </p>
        ) : (
          <div className="templates">
            {templates.map((template, idx) => {
              return (
                <div
                  className="template"
                  onClick={() => {
                    setTempIdx(idx);
                    setSelectedTemplate(template.id);
                    //   console.log(template.id);
                  }}
                  style={{
                    border:
                      tempIdx === idx
                        ? "3px solid cornflowerblue"
                        : "3px solid black",
                  }}
                >
                  <CerImgComp
                    imageUrl={
                      mainBaseUrl + template.certificateTemplateImage.uri
                    }
                  />
                  <div className="info">
                    <div className="templateName">{template.templateName}</div>
                    <div className="templateDescription">
                      {template.createdAt}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {/* <div className="bufferEmails">
          <h1>Buffer Emails </h1>
          {emailStatus >= 400 ? (
            <div className="container" style={{ height: "100px" }}>
              {certifiicateEmails.map((email) => {
                return (
                  <div>
                    <p>{email["email"]}</p>
                  </div>
                );
              })}
            </div>
          ) : (
            <p> Emails already added to buufer's list</p>
          )}
        </div> */}
      </div>
      <div
        onClick={btnValidator}
        style={{
          marginBottom: "10px",
          height: "50px",
          width: "200px",
          backgroundColor: "cornflowerblue",
        }}
        className="btn"
      >
        <p>Add</p>
      </div>
    </div>
  );
};

export default LeadTemp;
